import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '../service/auth.service';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    // Rights assign of menu to logged in user
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var isLogIn = this.authService.isUserLoggedIn();
        if (!isLogIn) {
            this.router.navigate(['/login']);
        }
        return true;
    }
}
